import { Button } from '@rio-cloud/rio-uikit';

interface DispatchEditableInfoProps {
    label: string;
    value?: string;
    editLabel: string;
    onEdit: () => void;
}

const DispatchEditableInfo = ({ label, value, editLabel, onEdit }: DispatchEditableInfoProps) => (
    <>
        <span className='text-color-dark font-semibold text-size-14'>{label}</span>
        <div className='flex items-center gap-2'>
            <span className='text-color-dark text-size-14 truncate min-w-0' title={value || undefined}>
                {value || '-'}
            </span>
            <Button
                variant={Button.VARIANT_LINK}
                bsSize={Button.XS}
                iconOnly
                iconName='rioglyph-pencil'
                className='shrink-0'
                title={editLabel}
                aria-label={editLabel}
                onClick={onEdit}
            />
        </div>
    </>
);

export default DispatchEditableInfo;
